import { useDesktopStore } from '../../stores/desktopStore'
import { useWindowStore } from '../../stores/windowStore'
import './StartMenu.css'

interface MenuItem {
  id: string
  label: string
  icon: string
  appId?: string
  submenu?: MenuItem[]
}

const menuItems: MenuItem[] = [
  { id: 'about', label: 'About Persona', icon: 'i', appId: 'about' },
  { id: 'solutions', label: 'Solutions', icon: '■', appId: 'products' },
  { id: 'separator1', label: '', icon: '' },
  { id: 'terminal', label: 'Terminal', icon: '>', appId: 'terminal' },
  { id: 'files', label: 'File Manager', icon: '□', appId: 'filemanager' },
  { id: 'notepad', label: 'Notepad', icon: '≡', appId: 'notepad' },
  { id: 'calculator', label: 'Calculator', icon: '#', appId: 'calculator' },
  { id: 'separator2', label: '', icon: '' },
  { id: 'minesweeper', label: 'Minesweeper', icon: '*', appId: 'minesweeper' },
  { id: 'solitaire', label: 'Solitaire', icon: '♠', appId: 'solitaire' },
  { id: 'chess', label: 'Chess', icon: '♚', appId: 'chess' },
  { id: 'worldmap', label: 'World Map', icon: '◎', appId: 'worldmap' },
  { id: 'tradewars', label: 'TradeWars 2002', icon: '◆', appId: 'tradewars' },
  { id: 'lord', label: 'Red Dragon', icon: '🐉', appId: 'lord' },
  { id: 'separator3', label: '', icon: '' },
  { id: 'contact', label: 'Contact Us', icon: '@', appId: 'contact' },
]

export function StartMenu() {
  const setStartMenuOpen = useDesktopStore((state) => state.setStartMenuOpen)
  const openWindow = useWindowStore((state) => state.openWindow)

  const handleItemClick = (item: MenuItem) => {
    if (item.appId) {
      openWindow(item.appId, item.label, item.icon)
      setStartMenuOpen(false)
    }
  }

  return (
    <div className="start-menu" role="menu">
      {/* Header */}
      <div className="start-menu__header">
        <span className="start-menu__logo">PERSONA</span>
        <span className="start-menu__version">OS v1.0</span>
      </div>

      {/* Menu Items */}
      <div className="start-menu__items">
        {menuItems.map((item) =>
          item.label === '' ? (
            <div key={item.id} className="start-menu__separator" />
          ) : (
            <button
              key={item.id}
              className="start-menu__item"
              onClick={() => handleItemClick(item)}
              role="menuitem"
            >
              <span className="start-menu__item-icon">{item.icon}</span>
              <span className="start-menu__item-label">{item.label}</span>
            </button>
          )
        )}
      </div>

      {/* Footer */}
      <div className="start-menu__footer">
        <span>Persona Science © 2025</span>
      </div>
    </div>
  )
}
